var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 2,
    fill: "#150349"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9537 8.91394L10.0492 10.0471L11.1157 8.02357L10.0492 6L11.9537 7.1332L13.8582 6L12.7917 8.02357L13.8582 10.0471L11.9537 8.91394ZM21.0955 16.8463L23 15.7131L21.9335 17.7367L23 19.7603L21.0955 18.6271L19.1909 19.7603L20.2575 17.7367L19.1909 15.7131L21.0955 16.8463ZM23 6L21.9335 8.02357L23 10.0471L21.0955 8.91394L19.1909 10.0471L20.2575 8.02357L19.1909 6L21.0955 7.1332L23 6ZM16.4027 14.7256L18.2615 12.7506L16.6465 11.0346L14.7876 13.0096L16.4027 14.7256ZM17.1874 10.2819L18.97 12.1759C19.2671 12.4754 19.2671 13.0015 18.97 13.3172L10.0796 22.7632C9.78253 23.0789 9.28735 23.0789 9.00548 22.7632L7.22283 20.8692C6.92572 20.5697 6.92572 20.0436 7.22283 19.7279L16.1132 10.2819C16.4103 9.96619 16.9055 9.96619 17.1874 10.2819Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.703db80b2e71e06df76952d177b0b0d7.svg";
export { ForwardRef as ReactComponent };